import { render, staticRenderFns } from "./ScanTypeConfirm.vue?vue&type=template&id=62422de2&scoped=true&"
import script from "./ScanTypeConfirm.vue?vue&type=script&lang=js&"
export * from "./ScanTypeConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ScanTypeConfirm.vue?vue&type=style&index=0&id=62422de2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62422de2",
  null
  
)

export default component.exports